module.exports = __webpack_public_path__ + "img/edge-logo.cbc57a92.svg";